import { Injectable } from '@angular/core';
import {CrudService} from './crud.service';
import {Observable} from 'rxjs';
import {UrlServer} from '../helpers/UrlServer';
import {getUserId} from '../helpers/utilities';

@Injectable({
  providedIn: 'root'
})
export class SaldoAgenteService {

  constructor(private crudService: CrudService) {
  }

  retirarSaldo(params: any = {}): Observable<any> {
    return this.crudService.update(params, UrlServer.saldoAgente);
  }

  list(params: any): Observable<any> {
    return this.crudService.list(params, UrlServer.saldoAgente);
  }

  getMiSaldo(): Observable<any> {
    const userId = getUserId();
    return this.crudService.get(userId, UrlServer.saldoAgente);
  }

  // getFilterQuestions(): QuestionBase<any>[] {
  //   const questions: QuestionBase<any>[] = [
  //     new DropdownQuestion({
  //       key: 'agente',
  //       label: 'Agente',
  //       options: [],
  //       optionConfig: ID_NOMBRE_OPTION_CONFIG,
  //     }),
  //   ];
  //   return questions;
  // }
}
